export interface ISystemStatus {
    isOnline: boolean;
}

export class SystemStatus implements ISystemStatus {
    isOnline: boolean;

    constructor(isOnline: boolean) {
        this.isOnline = isOnline;
    }
}



/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/systemHealthRetriever/system-status.ts
 **/